<template>
  <div class="modal-top">
    <slot />
  </div>
</template>

<script lang="ts" setup></script>

<style lang="scss" scoped>
@use '@/design-system/design-tokens/variables.scss';
.modal-top {
  background: variables.$color-pure-white;
  box-shadow: variables.$box-shadow-elevation-1-bottom;
  display: flex;
  height: 80%;
  overflow: hidden;
  padding: calc(#{variables.$padding-small} * 5) 0 calc(#{variables.$padding-small} * 19);
  position: absolute;
  top: 0;
  width: 100%;
  z-index: variables.$z-index-overlay-modal;
}
@media screen and (max-width: 1024px) {
  .modal-top {
    height: 100%;
    padding: calc(#{variables.$padding-small} * 5) 0 calc(#{variables.$padding-small} * 19);
  }
}
@media screen and (max-width: 658px) {
  .modal-top {
    height: 100%;
    padding: calc(#{variables.$padding-small} * 5) 0 calc(#{variables.$padding-small} * 19);
  }
}
</style>
